// extracted by mini-css-extract-plugin
export default {"l":"Text_l__lm7az","m":"Text_m__0gyOQ","s":"Text_s__YbZwy","semibold":"Text_semibold__teQ2k","bold":"Text_bold__oAmsx","regular":"Text_regular__oLVsq","medium":"Text_medium__cpWsQ"};